// @flow

import {
  SHOW_CONTACT_FORM,
  SET_PLACES,
  SET_CURRENT_PLACE,
  SET_CATEGORIES,
  SET_CURRENT_CATEGORY_ID,
  SET_HOVERED_STUDIO_INTERNAL_NAME,
  SET_BRANDS,
} from './actions';
import type { PlaceType, CategoryType, BrandType } from '../api/types';
import type { ActionType } from './actionsCreators';

export type DefaultStateType = {
  showContactForm: boolean,
  currentPlace: PlaceType,
  currentCategoryId: ?number,
  hoveredStudioInternalName: string,
  places: Array<PlaceType>,
  categories: Array<CategoryType>,
  brands: Array<BrandType>,
};

export const EMPTY_PLACE = {
  name: '',
  image: null,
  id: null,
};

const getCurrentPlace = (): PlaceType => {
  const currentPlace = localStorage.getItem('currentPlace');

  return currentPlace ? JSON.parse(currentPlace) : EMPTY_PLACE;
};

export const DEFAULT_STATE = {
  showContactForm: false,
  currentPlace: getCurrentPlace(),
  currentCategoryId: null,
  hoveredStudioInternalName: '',
  places: [],
  categories: [],
  brands: [],
};

const reducer = (state: DefaultStateType = DEFAULT_STATE, action: ActionType) => {
  switch (action.type) {
    case SHOW_CONTACT_FORM:
      return { ...state, showContactForm: action.payload };

    case SET_PLACES:
      return { ...state, places: action.payload };

    case SET_CURRENT_PLACE:
      return { ...state, currentPlace: action.payload };

    case SET_CATEGORIES:
      return { ...state, categories: action.payload };

    case SET_CURRENT_CATEGORY_ID:
      return { ...state, currentCategoryId: action.payload };

    case SET_HOVERED_STUDIO_INTERNAL_NAME: {
      return { ...state, hoveredStudioInternalName: action.payload };
    }

    case SET_BRANDS:
      return { ...state, brands: action.payload };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers.js